<template>
  <div>
    <div class="uk-margin">
      <router-view
        :key="$route.fullPath"
        name="eventView"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import EventModel from '../../models/EventModel';
import * as Sentry from '@sentry/vue';

@Component
export default class App extends Vue {
  open = false;

  created(): void {
    this.$store.dispatch('modules/loadModule', 'events-submissions').then(resp => {

      const getReferrerBaseURL = (referrer: string): string => {
        const url = new URL(referrer);
        return `${url.protocol}//${url.hostname}`;
      };

      // Additional client side check to prevent the iframe being embedded in unauthorized sites.
      if (window.top !== window.self) {
        if (!resp.context.allowedAncestors.includes(getReferrerBaseURL(document.referrer))) {
          this.$destroy();
          document.body.innerHTML = 'Access denied from this site.';
        }
      }

      this.$i18n.add(resp.i18n.locale, resp.i18n.strings);
      Sentry.init({
        Vue,
        environment: resp.context.sentry.env,
        dsn: resp.context.sentry.dsn,
        release: resp.context.sentry.release,
        integrations: [
          Sentry.replayIntegration(),
          Sentry.browserTracingIntegration(),
        ],
        trackComponents: true,
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: resp.context.sentry.env === 'production' ? 0.1 : 0,
        replaysOnErrorSampleRate: 1.0,
      });
    });

    this.$store.dispatch('context/fetchUser').catch((e) => { return; });
  }

  get events(): Array<EventModel> {
    return this.$store.getters['events/activeEvents']();
  }
}
</script>

<style scoped>

</style>
